module.exports = __webpack_public_path__ + "img/slide24.aa061242.png";